export default "__VITE_ASSET__C4Fdq_9I__"